export class VenueAdminReportData {
  overbookedReportVenueIds: number[];
}
